<template>
    <v-row no-gutters class="d-flex justify-center">
        <v-col cols="12" class="d-flex justify-center">
            <pdf :source="src || signedUrl" style="width: 100%" />
        </v-col>
    </v-row>
</template>

<script lang="ts">
import pdf from "vue-pdf-embed";

import GET_DOCUMENT_PDF from "@/graphql/GetDocumentPDF.gql";

import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        pdf,
    },
})
export class PublicDocumentPDF extends Vue {
    @Prop({ default: "" }) documentId: string;
    @Prop({ default: "" }) signedUrl: string;
    numPages = 0;

    @Apollo({
        query() {
            return GET_DOCUMENT_PDF;
        },
        variables() {
            return {
                id: this.documentId,
            };
        },
        skip() {
            return !this.documentId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data.getDocumentWithoutAuth?.originalSignedUrl) {
                this.src = data.getDocumentWithoutAuth.originalSignedUrl;
            }
        },
    })
    src = "";

    // pages = []
}

export default toNative(PublicDocumentPDF);
</script>
